/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_PRESENTATION } from "../graphql";
import { VApplication } from "../../../application";
const log: any = LoggerModule?.getInstance();

export interface UpdatePresentationProps {
  id: string;
  status: string;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdatePresentationMethods extends IPluginMethodMap {
  updatePresentation(args: any): Promise<any>;
}

export class UpdatePresentationService implements IAgentPlugin {
  readonly methods: IUpdatePresentationMethods;

  constructor() {
    this.methods = {
      updatePresentation: this.updatePresentation.bind(this),
    };
  }

  async updatePresentation(args: UpdatePresentationProps) {
    log.blue(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: UPDATE_PRESENTATION,
          variables: {
            filter: {
              _id: args?.id,
            },
            update: {
              status: args?.status,
            },
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data) {
          return {
            ...res?.data?.updatePresentation,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
      err?.graphQLErrors &&
      Array.isArray(err?.graphQLErrors) &&
      err?.graphQLErrors.find((item: any) => item.extensions);
    if (_display_message?.extensions?.display_message) {
      throw Error(_display_message?.extensions?.display_message);
    }

    throw err;
    }
  }
}
